/**
 * Default quad values based on page domain
 * @type {Object}
 */
export const defaultQuadLinkValues = {
	// TODO: Remove m. values since we only use the desktop url
	'modernize.com': {
		showers: {
			c: '1683621',
			s: '3086',
			f: '202309141602090'
		},
		default: {
			c: '1679227',
			s: '29914',
			f: '202202161521310'
		},
		'cost-calculator': {
			default: {
				c: '1679227',
				s: '29914',
				f: '202202161521310'
			}
		}
	},
	'm.homewindowprices.org': {
		c: '1673838',
		s: '3086',
		f: '202010191645180'
	},
	'quotes.bathwraps.com': {
		c: '1660429',
		s: '26393',
		f: '201812121510250'
	},
	'm.bathwraps.com': {
		c: '1660426',
		s: '26401',
		f: '201812121509080'
	},
	'craftmaticbeds.com': {
		c: '655234',
		s: '3086',
		f: '201008201638230'
	},
	'm.emedicalalerts.com': {
		c: '1647405',
		s: '26401',
		f: '201711071755190'
	},
	'bathrooms.improvementcenter.com': {
		c: '1652509',
		s: '26401',
		f: '201803221337420'
	},
	'gutters.improvementcenter.com': {
		c: '1635550',
		s: '16479',
		f: '201703010604120'
	},
	'stairlifts.improvementcenter.com': {
		c: '1658465',
		s: '26401',
		f: '201809260926240'
	},
	'walkintubs.improvementcenter.com': {
		c: '1647564',
		s: '26401',
		f: '201711081408460'
	},
	'go.medicalguardian.com': {
		c: '1654232',
		s: '26393',
		f: '201805101622250'
	},
	'powerhomesolarpanels.com': {
		c: '1676761',
		s: '3086',
		f: '202105251631450'
	},
	'topgutterpros.com': {
		c: '1683689',
		s: '3086',
		f: '202309251220170'
	},
	'topremodelingpros.com': {
		c: '1683689',
		s: '3086',
		f: '202309251220170'
	},
	'bestcompany.modernize.com': {
		homewarranty: {
			c: '1684628',
			s: '34486',
			f: '202401301751220'
		},
		medicalalertsystems: {
			c: '1684826',
			s: '34486',
			f: '202402151655050'
		},
		homesecurity: {
			c: '1684824',
			s: '34486',
			f: '202402151653100'
		},
		solar: {
			c: '1684620',
			s: '34486',
			f: '202401301731070'
		},
		watersofteners: {
			c: '1684830',
			s: '34486',
			f: '202402141206230'
		},
		plumbing: {
			c: '1684766',
			s: '34486',
			f: '202402141115530'
		},
		treeservices: {
			c: '1684764',
			s: '34486',
			f: '202402141113540'
		},
		newwindows: {
			c: '1684828',
			s: '34486',
			f: '202402151656490'
		},
		walkintubs: {
			c: '1684760',
			s: '34486',
			f: '202402141109100'
		},
		stairlifts: {
			c: '1684758',
			s: '34486',
			f: '202402141106430'
		},
		siding: {
			c: '1684756',
			s: '34486',
			f: '202402141103210'
		},
		roofing: {
			c: '1684754',
			s: '34486',
			f: '202402141059590'
		},
		hvac: {
			c: '1684752',
			s: '34486',
			f: '202402141057220'
		},
		hottubs: {
			c: '1684750',
			s: '34486',
			f: '202402141054450'
		},
		gutters: {
			c: '1684748',
			s: '34486',
			f: '202402141051430'
		},
		flooring: {
			c: '1684746',
			s: '34486',
			f: '202402141049110'
		},
		doors: {
			c: '1684744',
			s: '34486',
			f: '202402141046440'
		},
		cabinets: {
			c: '1684822',
			s: '34486',
			f: '202402151651120'
		},
		bathroomremodel: {
			c: '1684820',
			s: '34486',
			f: '202402151646230'
		},
		findapro: {
			c: '1684895',
			s: '3086',
			f: '202402231339130'
		}
	},
	'bestcompany.com': {
		homewarranty: {
			c: '1684628',
			s: '34486',
			f: '202401301751220'
		},
		medicalalertsystems: {
			c: '1684826',
			s: '34486',
			f: '202402151655050'
		},
		homesecurity: {
			c: '1684824',
			s: '34486',
			f: '202402151653100'
		},
		solar: {
			c: '1684620',
			s: '34486',
			f: '202401301731070'
		},
		watersofteners: {
			c: '1684830',
			s: '34486',
			f: '202402141206230'
		},
		plumbing: {
			c: '1684766',
			s: '34486',
			f: '202402141115530'
		},
		treeservices: {
			c: '1684764',
			s: '34486',
			f: '202402141113540'
		},
		newwindows: {
			c: '1684828',
			s: '34486',
			f: '202402151656490'
		},
		walkintubs: {
			c: '1684760',
			s: '34486',
			f: '202402141109100'
		},
		stairlifts: {
			c: '1684758',
			s: '34486',
			f: '202402141106430'
		},
		siding: {
			c: '1684756',
			s: '34486',
			f: '202402141103210'
		},
		roofing: {
			c: '1684754',
			s: '34486',
			f: '202402141059590'
		},
		hvac: {
			c: '1684752',
			s: '34486',
			f: '202402141057220'
		},
		hottubs: {
			c: '1684750',
			s: '34486',
			f: '202402141054450'
		},
		gutters: {
			c: '1684748',
			s: '34486',
			f: '202402141051430'
		},
		flooring: {
			c: '1684746',
			s: '34486',
			f: '202402141049110'
		},
		doors: {
			c: '1684744',
			s: '34486',
			f: '202402141046440'
		},
		cabinets: {
			c: '1684822',
			s: '34486',
			f: '202402151651120'
		},
		bathroomremodel: {
			c: '1684820',
			s: '34486',
			f: '202402151646230'
		},
		findapro: {
			c: '1684895',
			s: '3086',
			f: '202402231339130'
		}
	},
	'topsolarcompanies.com': {
		c: '1684497',
		s: '34399',
		f: '202401241741100'
	},
	'besthomesecuritycompanys.com': {
		c: '1684495',
		s: '34399',
		f: '202401241738220'
	},
	'leafguardpros.com': {
		c: '1687885',
		s: '35730',
		f: '202501171141140'
	}
};
